"use client";

import { Suspense, use, useEffect } from "react";
import { useStores } from "../../stores/useStores";

function UnreadNotificationsConsumerChild(props: {
  unreadNotificationsPromise: Promise<any> | null;
}) {
  const { userStore } = useStores();
  const notificationData = props.unreadNotificationsPromise
    ? use(props.unreadNotificationsPromise)
    : null;

  useEffect(() => {
    if (notificationData) {
      userStore.setUnreadNotifications(notificationData);

      if (navigator.setAppBadge) {
        if (notificationData.total > 0) {
          navigator.setAppBadge(notificationData.total);
        } else {
          navigator.clearAppBadge();
        }
      }
    }
  }, []);

  return <></>;
}

export function UnreadNotificationsConsumer(props) {
  return (
    <Suspense>
      <UnreadNotificationsConsumerChild {...props} />
    </Suspense>
  );
}
